import React from "react";
import PaymentVoucher from './Payment_Voucher';

const PayVchrApp = () =>{
    return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Payment Voucher</h5>
          </div>
        </div>
        <PaymentVoucher />
      </div>
    </div >
  );
};

export default PayVchrApp;
